var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('r-title',[_vm._v(_vm._s(_vm._f("titlecase")(_vm.$t("views.task-list-unsent.title"))))]),_c('TaskList',{attrs:{"tasks":_vm.unsubmittedTasks,"show-customer":"","show-upload-date":"","show-action":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }